import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Pill from '../Pill'
import styles from './SelectablePill.module.scss'

const propTypes = {
  /**
   * content of the pill
   */
  children: PropTypes.node.isRequired,
  /**
   * Defines if pill is selected or not
   */
  selected: PropTypes.bool,
  /**
   * Callback when pill is clicked
   */
  onChange: PropTypes.func,
}

function SelectablePill(props) {
  const { children, selected = false, onChange = () => {} } = props ?? {}

  return (
    <button type="button" className={styles.transparentButton} onClick={() => onChange(!selected)}>
      <Pill className={clsx(selected && 'text-color-primary')} textGray={!selected}>
        {children}
        {selected ? (
          <i className={clsx('fas fa-xmark ms-2', styles.iconSize)} />
        ) : (
          <i className={clsx('fas fa-plus ms-2 text-color-primary', styles.iconSize)} />
        )}
      </Pill>
    </button>
  )
}

SelectablePill.propTypes = propTypes

export default SelectablePill
